import { PropsWithChildren } from "react"

import { Property } from "csstype"

type FlexProps = PropsWithChildren<
    {
        direction?: Property.FlexDirection,
        justifyContent?: Property.JustifyContent,
        alignItems?: Property.AlignItems,
        alignContent?: Property.AlignContent,
        gap?: Property.Gap,
        wrap?: Property.FlexWrap,
        minHeight?: Property.MinHeight,
        height?: Property.Height,
        maxHeight?: Property.MaxHeight,
        minWidth?: Property.MinWidth,
        width?: Property.Width,
        maxWidth?: Property.MaxWidth,
    } & React.HTMLAttributes<HTMLDivElement>
>

const Flex = ({
    children,
    direction = 'column',
    justifyContent = 'space-between',
    alignItems = 'start',
    ...rest }: FlexProps) => (
    <div
        style={{
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: direction,
            justifyContent: justifyContent,
            alignItems: alignItems,
            alignContent: rest.alignContent,
            gap: rest.gap,
            flexWrap: rest.wrap,
            minHeight: rest.minHeight,
            height: rest.height,
            maxHeight: rest.maxHeight,
            minWidth: rest.minWidth,
            width: rest.width || '100%',
            maxWidth: rest.maxWidth,
            ...rest.style,
        }}>
        {children}
    </div>
)

export const FlexRow = ({ ...rest }: FlexProps) => (
    <Flex direction="row" {...rest} />
)

export const FlexColumn = ({ ...rest }: FlexProps) => (
    <Flex direction="column" {...rest} />
)